import { render, staticRenderFns } from "./ButtonClose.vue?vue&type=template&id=4432a5e0&scoped=true&"
import script from "./ButtonClose.vue?vue&type=script&lang=js&"
export * from "./ButtonClose.vue?vue&type=script&lang=js&"
import style0 from "./ButtonClose.vue?vue&type=style&index=0&id=4432a5e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4432a5e0",
  null
  
)

export default component.exports